<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <Tabs class="router-view" :animated="false" v-model="active" @on-click="tabsChange">
                <TabPane label="客户列表" :index="1" name="customerList">
                    <Access name="customerList">
                        <router-view
                            v-if="active == 'customerList'"
                            :name="$access.aliasToUri('customerList')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="客户评价" :index="2" name="customerEvaluate">
                    <Access name="customerEvaluate">
                        <router-view
                            v-if="active == 'customerEvaluate'"
                            :name="$access.aliasToUri('customerEvaluate')"
                        ></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'ivux'
export default {
    components: {
        Tabs,
        TabPane
    },
    data() {
        return {
            active: 'customerList'
        }
    },
    methods: {
        tabsChange(el) {}
    }
}
</script>